<div class="p-col p-field">
  <div>
    <p-progressBar [value]="loadingPercent"></p-progressBar>
  </div>
  <div class="p-mt-4">
    <p-message severity="warn" class="p-mt-2" text="El proceso se irá ejecutando en segundo plano, si lo desea puede cerrar esta ventana y continuar con su trabajo."></p-message>
  </div>
</div>
<button pButton class="p-button-secondary" style="float: right;" (click)="cancel()">Cerrar ventana</button>
